/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IDobbiesCookiesInformationViewProps } from './dobbies-cookies-information';

export default (props: IDobbiesCookiesInformationViewProps) => {
    const { heading, paragraph, table } = props;
    return (
        <div>
            {heading}
            {paragraph}
            {table}
        </div>
    );
};
